import React from 'react';

interface Props {
  code: string;
}

const StatusBadge: React.FC<Props> = ({ code }) => (
  <div className="badge-base">
    <div className="badge-text ml-0">
      <span>{code}</span>
    </div>
  </div>
);

export default React.memo(StatusBadge);
